import { Button, Paper, Grid, Select, Stack } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import TableWithLoaderCifrasRDI from './TableWtithLoaderCifrasRDI';
import axios from 'axios';



const DataPanelCifrasRDI = () => {
    const [allData, setAllData] = useState([]);
    const [headerst, setHeaders] = useState([]);

    const [value, setValue] = useState(null);

    const consultarReporte = async () => {
        const startDate = value + '-01-01';
        const endDate = value + '-12-31';

        try {
            const response = await axios.post(process.env.REACT_APP_API_ENP + "/sscn-back/api/rdi/getTotalesRDI",
                { "initDate": startDate, "endDate": endDate },
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    }
                }
            );

            setAllData(response.data.map(obj => {
                const { ['MesNo']: _, ...rest } = obj;
                return rest;
            }));
            const headers = Array.from(
                new Set(response.data.flatMap(obj => Object.keys(obj)))
            );
            headers.shift()
            setHeaders(headers);
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    }

    return (
        <>
            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md">
                    <Paper shadow="xl" radius="xl" withBorder p="xl">
                        <Grid justify="center" align="center">
                            <Grid.Col span={3}>
                                <Select
                                    value={value}
                                    onChange={setValue}
                                    label="Elige un año"
                                    placeholder=""
                                    data={['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027']}
                                />
                            </Grid.Col>
                        </Grid>

                        <Grid justify="center" align="center">
                            <Grid.Col span={1} >
                                <Button variant="outline" color="rgba(2, 12, 65, 1)" onClick={consultarReporte}>Consultar</Button>
                            </Grid.Col>
                        </Grid>
                    </Paper>
                    {allData.length !== 0 ? <TableWithLoaderCifrasRDI heigth={500} allData={allData} headers={headerst} /> : <></>}
                </Stack>
            </div>
        </>
    );
};

export default DataPanelCifrasRDI;